export function formatNumber(n) {
  if (n === null || n === undefined || isNaN(Number(n))) return '-';
  return Number(n).toLocaleString('en-IN');
}

export function formatCurrency(n) {
  if (n === null || n === undefined || isNaN(Number(n))) return '₹ 0';
  return '₹ ' + Number(n).toLocaleString('en-IN', { maximumFractionDigits: 0 });
}

export function formatDate(d) {
  if (!d) return '-';
  try { return new Date(d).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: '2-digit' }); } catch { return d; }
}

export function formatDateTime(d) {
  if (!d) return '-';
  try { return new Date(d).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' }); } catch { return d; }
}

export function statusColor(status) {
  const s = (status || '').toLowerCase();
  if (['green', 'closed', 'done', 'on_track', 'achieved', 'valid', 'submitted', 'approved', 'uploaded', 'a'].includes(s)) return 'bg-[#ECFDF5] text-[#15803D] border-[#BBF7D0]';
  if (['amber', 'in_progress', 'pending', 'at_risk', 'expiring_soon', 'draft', 'open', 'b'].includes(s)) return 'bg-[#FFF7E8] text-[#C2410C] border-[#FDE68A]';
  if (['red', 'overdue', 'missed', 'expired', 'failed', 'critical', 'c', 'd'].includes(s)) return 'bg-[#FFF1F2] text-[#DC2626] border-[#FECDD3]';
  return 'bg-[#F1F5F9] text-[#475569] border-[#E2E8F0]';
}

export function statusDot(status) {
  const s = (status || '').toLowerCase();
  if (['green', 'closed', 'done', 'on_track', 'achieved', 'submitted', 'approved', 'uploaded'].includes(s)) return 'bg-[#22C55E]';
  if (['amber', 'in_progress', 'pending', 'at_risk', 'draft', 'open'].includes(s)) return 'bg-[#F59E0B]';
  if (['red', 'overdue', 'missed', 'failed', 'critical'].includes(s)) return 'bg-[#EF4444]';
  return 'bg-slate-400';
}
